<template>
  <div class="channel_layer fx fdc">
    <Header :title="$tp('header.title.channel')"></Header>
    <div v-if="ready" v-loading="!ready" class="_fill">
      <div v-if="show_channel" class="channel_frame">
        <!-- 頻道邀請 -->
        <div class="invite_ctn" v-for="data in invitations">
          <div class="title_box">
            <div class="title">頻道邀請</div>
            <div class="date">{{moment2("local-datetime", data.createdAt)}}</div>
          </div>
          <div class="text">您已被加入{{data.channelName}}頻道。</div>
          <div class="actions">
            <div class="main_btn _plain" @click="replyInvitation(data, 'rejected')">拒絕</div>
            <div class="main_btn _main" @click="replyInvitation(data, 'accepted')">接受</div>
          </div>
        </div>
        <template v-for="data in computeChannels">
          <div class="channel_ctn" @click="toPage('room', data)">
            <div class="image_box _channel">
              <div v-if="data.imageUrl" class="image" :style="{backgroundImage: `url(${data.imageUrl})`}"></div>
              <el-avatar v-else :size="48" :src="require('@/assets/img/default_channel.svg')"></el-avatar>
            </div>
            <div class="channel_box">
              <div class="title_box">
                <div class="title">{{data.channelName}}</div>
                <div class="mute" v-if="data.muted"><img src="./img/mute.svg"></div>
                <div class="date">{{moment2("timeago", data.dataTime)}}</div>
              </div>
              <div class="content_box">
                <div class="content">
                  <div class="status">{{data.item}}</div>
                  <div class="text" line-clamp>{{data.content}}</div>
                </div>
                <div v-show="data.unreadCount" class="unread">{{label("unreadCount", data)}}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <ResultPage v-else>
        <div class="no_channel">
          您尚未加入任何頻道<br>
          請聯繫頻道管理員發送邀請
        </div>
      </ResultPage>
    </div>

    <ResultPage v-else>
      <div class="no_channel">
        載入中...<br>
        如持續停留此畫面<br>
        請重啟 App 後再試
      </div>
    </ResultPage>

    <router-view />
  </div>
</template>

<script>
//api
import { getInvitations, replyInvitation } from "@/api/channel";
//utils
import { moment2 } from "@u/methods";

export default {
  mixins: [
    require("@mix/channel").default,
    require("@mix/webview").default,
    require("@mix/timer").default,
  ],
  data() {
    return {
      ready: false,
      invitations: [],
    }
  },
  computed: {
    ...mapGetters(["notifyToken"]),
    moment2: () => moment2,
    show_channel() { return this.invitations.length || this.channels.length },
    computeChannels() {
      return this.channels.map(data => {
        data.imageUrl = data.images?.[0]?.url;
        return data;
      })
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    label(type, targetData) {
      if (type === "unreadCount") {
        let result = Math.min(999, targetData.unreadCount);
        if (targetData.unreadCount > result) result += "+";
        return result;
      }
    },
    async init() { //不要隨便叫 getData, 會被 @mix/webview 的 activated 呼叫
      this.clear_timer();

      await this.fetchData();
      this.ready = true;

      // 新增新的計時器
      this.timer.push(setInterval(() => {
        this.fetchData();
      }, 2000));
    },
    async fetchData() {
      try {
        await Promise.all([
          this.getInvitations(),
          this.$store.dispatch("GetChannels")
        ])
      } catch (ex) {
        console.log("fetchData:", ex)
      }
    },
    toPage(type, targetData) {
      switch (type) {
        case "room": this.$router.push({ path: `/channel/room/${targetData.channelID}` }); break;
      }
    },
    getInvitations() {
      return getInvitations().then(res => {
        if (res.data) {
          // appCallAlert(`this.invitations: ${JSON.stringify(res.data)}\nfrom: ${from}\nresType: ${JSON.stringify(typeof res.data)}`);
          this.invitations = res.data;
        } else {
          this.invitations = []; // 確保至少是空陣列
        }
      }).catch(error => {
        console.error('獲取邀請失敗:', error);
        this.invitations = []; // 錯誤時也設為空陣列
      });
    },
    replyInvitation(targetData, reply) {
      replyInvitation(targetData._id, reply).then(res => {
        this.fetchData();
      }).catch(error => {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: "頻道邀請設定" }));
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.channel_layer {
  height: 100%;
  .no_channel {
    color: $gray_70;
  }
  .channel_frame {
    background-color: #ffffff;
    height: 100%;
    overflow-y: auto;
  }
}
.channel_frame {
  .invite_ctn {
    background-color: $gray_95;
    border-bottom: 1px solid $gray_90;
    padding: 0.8rem 1rem;
    .title_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 1;
      .title {
        font-size: 80%;
      }
      .date {
        font-size: 70%;
        letter-spacing: 0;
      }
    }
    .text {
      font-size: 70%;
      margin-top: 0.4rem;
      color: $gray_40;
    }
    .actions {
      margin-top: 0.8rem;
      display: flex;
      justify-content: flex-end;
      > div {
        width: 4.5rem;
        font-size: 60%;
        height: 1.6rem;
        line-height: 1.6rem;
        &:not(:last-child) {
          margin-right: 0.4rem;
        }
      }
    }
  }
  .channel_ctn {
    @include buttonEnhance();
    background-color: #ffffff;
    padding: 1rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $gray_95;
    .image_box {
      @include image-box(2.4rem);
      margin-right: 0.6rem;
    }
    //
    .channel_box {
      width: 100%;
    }
    //
    .title_box {
      display: flex;
      align-items: center;
      .title {
        font-size: 80%;
      }
      .mute {
        position: relative;
        top: 0.05rem;
        width: 0.6rem;
        margin-left: 0.4rem;
      }
      .date {
        color: $gray_60;
        margin-left: auto;
        font-size: 70%;
        letter-spacing: 0;
      }
    }
    .content_box {
      display: flex;
      align-items: center;
      margin-top: 0.2rem;
      .content {
        color: $gray_60;
        font-size: 70%;
        width: 100%;
      }
      .text {
        @include line_clamp(1);

        max-width: calc(100vw - 40px - 60px - 56px);
      }
    }
  }
}
</style>